<div
	class="flex justify-start rounded p-2 pr-4 w-full border color-secondary gap-2 relative"
	[class]="wrapperStyles()"
	[class.mb-3]="showBottomPadding()"
>
	<ui-icon
		class="mt-0.5"
		[class]="iconStyles()"
		[icon]="notifyIcons[type()]"
		[size]="sizes.M"
	></ui-icon>
	<div
		class="flex flex-col items-start min-w-0"
		[class.gap-2]="!collapsible()"
		[class.grow]="collapsible()"
	>
		@if (collapsible()) {
			<button
				class="flex w-full items-start justify-between gap-2 cursor-pointer text-left"
				type="button"
				(click)="toggle()"
				data-cy="ui-notify-toggle"
			>
				<span class="ui-notify__message" [innerHTML]="text()"></span>
				<ui-icon class="mt-0.5 shrink-0" [icon]="toggleIcon()" [size]="sizes.S"></ui-icon>
			</button>
		} @else if (text()) {
			<div class="ui-notify__message" [innerHTML]="text()"></div>
		}
		<div [class]="contentStyles()">
			<div [class]="innerContentStyles()">
				<ng-content></ng-content>
			</div>
		</div>
	</div>
	@if (closable()) {
		<div class="grow flex justify-end pt-1">
			<ui-icon icon="x_cross" class="cursor-pointer" (iconClicked)="closeNotify.emit()"> </ui-icon>
		</div>
	}
</div>
